<div *ngIf="(filteredIndividuals ?? []).length > 0" class="entity-card">
  <div class="section-header">
    <span>Individuals</span>
  </div>
  <div class="section-body">
    <div *ngFor="let individual of filteredIndividuals; let last = last"
         nz-row (click)="showIndividualModal(individual)"
         class="section-row"
         [ngClass]="{'section-row-border': !last}">
      <div nz-col nzSpan="11" class="section-col-left">
        <div class="section-col-left-content">
          <nz-avatar nzIcon="user" class="avatar"></nz-avatar>
          <div class="section-col-left-text">
            <div class="col-name">{{individual.lastName}} {{individual.firstName}} </div>
            <div class="col-email">{{individual.email}}</div>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="13" class="section-col-right">
        <div *ngFor="let role of getFilteredJobTitlesIndividual(individual)">
          <span class="role-badge">
            {{mapRoleToText(role)}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="(filteredBodyCorporates ?? []).length > 0" class="entity-card">
  <div class="section-header">
    <span>Body Corporates</span>
  </div>

  <div class="section-body">
    <div *ngFor="let bodycorporate of filteredBodyCorporates; let last = last"
         (click)="showBodyCorpModal(bodycorporate)"
         nz-row
         class="section-row section-row-border"
         [ngClass]="{'section-row-margin': !last}">
      <div nz-col nzSpan="11" class="section-col-left">
        <div class="section-col-left-content">
          <nz-avatar nzSrc="assets/icons/corporate.svg"></nz-avatar>
          <div class="section-col-left-text">
            <div class="col-name">{{bodycorporate?.companyDetails?.name}}</div>
            <div class="col-email">{{bodycorporate?.companyDetails?.registrationNumber}}</div>
          </div>
        </div>
      </div>
      <div nz-col nzSpan="13" class="section-col-right">
        <div *ngFor="let role of getFilteredJobTitlesBodyCorporated(bodycorporate)">
          <span class="role-badge">
            {{mapRoleToText(role)}}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="collapse-wrapper">
    <nz-collapse [nzBordered]="false" class="sections-collapse">
      <nz-collapse-panel nzHeader="Additional information">
        <ng-container *ngFor="let question of additionalInfoQuestions; let i = index">
          <div class="collapse-section">
            <div class="question-block">
              <div class="question-label">
                <span>{{i + 1}}. </span><span [innerHTML]="question.question"></span>
              </div>
              <div class="question-value" *ngIf="question.value != null">
                {{question.value == true ? "Yes" : "No"}}
              </div>
            </div>
          </div>
        </ng-container>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
</div>
